<form [formGroup]="form">
  @for (item of miscItems.controls; track item; let index = $index) {
    <ion-list lines="full" [inset]="true" class="no-last-line">
      @if (index === 0) {
        <ion-list-header>Miscellaneous Items</ion-list-header>
      }
      <ng-container [formGroup]="item">
        <ion-item>
          <ion-label>Misc Item #{{ index + 1 }}</ion-label>
        </ion-item>

        <ion-radio-group formControlName="type">
          <ion-item-divider>Type:</ion-item-divider>
          <ion-item>
            <ion-radio class="tw:text-xs" [value]="netSheetMiscItemTypeEnum.Credit">
              {{ netSheetMiscItemTypeEnum.Credit }}
            </ion-radio>
          </ion-item>
          <ion-item>
            <ion-radio class="tw:text-xs" [value]="netSheetMiscItemTypeEnum.Debit">
              {{ netSheetMiscItemTypeEnum.Debit }}
            </ion-radio>
          </ion-item>
        </ion-radio-group>

        <ion-item-divider>Details</ion-item-divider>

        <ion-item>
          <ion-input
            redErrorMessage
            formControlName="description"
            labelPlacement="stacked"
            placeholder="Eg. Misc. Adjustment"
            inputmode="text"
            type="text"
          >
            <div slot="label" class="tw:whitespace-normal">Description</div>
          </ion-input>
        </ion-item>

        <ion-item>
          <ion-input
            redErrorMessage
            formControlName="amount"
            labelPlacement="stacked"
            placeholder="$"
            inputmode="decimal"
            type="text"
            [maskito]="amountMask"
            [maskitoElement]="maskPredicate"
          >
            <div slot="label" class="tw:whitespace-normal">Amount</div>
          </ion-input>
        </ion-item>

        @if (miscItems.controls.length > 1) {
          <ion-item [button]="true" (click)="removeMiscItem(index)">
            <ion-label color="danger">Remove</ion-label>
          </ion-item>
        }
      </ng-container>
    </ion-list>
  }

  <ion-button color="secondary" class="tw:m-4" expand="block" (click)="addMiscItem()">
    Add Misc Item
    <ion-icon slot="end" name="add-circle-outline"></ion-icon>
  </ion-button>
</form>
